'use client';

import { type ReactNode } from 'react';

const enabled = process.env.NEXT_PUBLIC_MSW === '1';
let workerStartPromise: Promise<unknown> | undefined;

function startWorker() {
  if (!enabled || typeof window === 'undefined') {
    return;
  }

  workerStartPromise ??= import('./browser').then(({ worker }) =>
    worker.start({ onUnhandledRequest: 'bypass' }),
  );

  return workerStartPromise;
}

function gateFetchUntilWorkerStarts(startPromise: Promise<unknown>) {
  const originalFetch = window.fetch;
  const gatedFetch: typeof window.fetch = (...args) =>
    startPromise.then(
      () => {
        const startedFetch = window.fetch === gatedFetch ? originalFetch : window.fetch;
        return startedFetch(...args);
      },
      (error) => Promise.reject(error),
    );

  window.fetch = gatedFetch;
  void startPromise.then(
    () => {
      if (window.fetch === gatedFetch) {
        window.fetch = originalFetch;
      }
    },
    (error) => {
      console.error('[MSW] Failed to start mocking.', error);
    },
  );
}

const startupPromise = startWorker();
if (startupPromise) {
  gateFetchUntilWorkerStarts(startupPromise);
}

export function MswProvider({ children }: Readonly<{ children: ReactNode }>) {
  return children;
}
